import { useIsInMobileWebView } from './useIsInMobileWebView';
import { useIsWizardView } from './useIsWizardView';

/** Pages rendered without the app's nav, footer and page-level banners: mobile webviews and wizard views. */
export const useIsChromelessView = (): boolean => {
  const isInMobileWebView = useIsInMobileWebView();
  const isWizardView = useIsWizardView();

  return isInMobileWebView === true || isWizardView === true;
};
